import type { TranslationKey } from './en.js';

export const de: Partial<Record<TranslationKey, string>> = {
  'app.name': 'Volt',

  'section.chat': 'Chat',
  'section.image': 'Bilder',
  'section.video': 'Video',
  'section.video2': 'Video 2 (Marketing Studio)',
  'section.character': 'Charakter',
  'section.audio': 'Musik & Audio',
  'section.voice': 'Stimme',
  'section.design': 'Design',

  'common.loading': 'Wird geladen…',
  'common.error': 'Etwas ist schiefgelaufen',
  'common.retry': 'Erneut versuchen',
  'common.refresh': 'Aktualisieren',
  'common.cancel': 'Abbrechen',
  'common.confirm': 'Bestätigen',
  'common.save': 'Speichern',
  'common.close': 'Schließen',
  'common.delete': 'Löschen',
  'common.create': 'Erstellen',
  'common.apply': 'Anwenden',
  'common.offline': 'Offline — zwischengespeicherte Daten',
  'common.you': 'Du',
  'common.assistant': 'Assistent',
  'common.empty': 'Noch nichts hier',
  'common.back': 'Zurück',

  'auth.loading': 'Anmeldung läuft…',
  'auth.openInTelegram': 'Öffne mich in Telegram',
  'auth.openInTelegramHint':
    'Volt läuft als Telegram Mini App. Starte sie aus deinem Chat mit dem Bot, um dich anzumelden.',
  'auth.retry': 'Erneut versuchen',
  'auth.error': 'Anmeldung fehlgeschlagen',
  'auth.devHint': 'Entwicklervorschau — ohne Telegram-Daten.',

  'topbar.menu': 'Menü öffnen',
  'topbar.settings': 'Einstellungen',
  'topbar.balance': 'Guthaben',

  'directChat.open': 'Privaten Chat öffnen',
  'pager.chat': 'Chat',
  'pager.label': 'Seitenwechsel',
  'directChat.title': 'Privater Chat',
  'directChat.yourId': 'Deine ID: {id}',
  'directChat.addPlaceholder': 'Öffentliche ID oder Telegram-@Benutzername',
  'directChat.addFriend': 'Freund hinzufügen',
  'directChat.addSelf': 'Du kannst dich nicht selbst als Freund hinzufügen.',
  'directChat.friends': 'Freunde',
  'directChat.noFriends':
    'Noch keine Freunde. Füge jemanden mit öffentlicher ID oder Telegram-@Benutzername hinzu.',
  'directChat.selectFriend': 'Wähle einen Freund für den Chat aus.',
  'directChat.noMessages': 'Noch keine Nachrichten. Sag Hallo!',
  'directChat.messagePlaceholder': 'Nachricht schreiben…',
  'directChat.send': 'Nachricht senden',
  'directChat.notFound': 'Mit dieser ID oder diesem Telegram-Benutzernamen wurde niemand gefunden.',
  'directChat.noPermission': 'Du kannst nur einem Freund schreiben.',
  'directChat.addError':
    'Prüfe die ID oder den Benutzernamen; vielleicht ist die Person bereits hinzugefügt.',
  'directChat.error': 'Chat konnte nicht geladen werden. Bitte erneut versuchen.',
  'directChat.openDrawer': 'Unterhaltungen öffnen',
  'directChat.chats': 'Unterhaltungen',
  'directChat.groups': 'Gruppen',
  'directChat.newGroup': 'Neue Gruppe',
  'directChat.createGroup': 'Gruppe erstellen',
  'directChat.groupName': 'Gruppenname',
  'directChat.selectMembers': 'Mitglieder auswählen ({count}/50 mit dir)',
  'directChat.memberCount': '{count} Mitglieder',
  'directChat.messages': 'Nachrichten',
  'directChat.messageActions': 'Nachrichtenaktionen',
  'directChat.reply': 'Antworten',
  'directChat.replyingTo': 'Antwort an {name}',
  'directChat.forward': 'Weiterleiten',
  'directChat.forwarded': 'Weitergeleitet',
  'directChat.chooseDestination': 'Unterhaltung zum Weiterleiten wählen',
  'directChat.deleteForMe': 'Für mich löschen',
  'directChat.deleteForEveryone': 'Für alle löschen',
  'directChat.deleteForEveryoneConfirm': 'Diese Nachricht für alle im Chat löschen?',
  'directChat.aiAttribution': 'Künstliche Intelligenz',
  'directChat.aiToggleEnabled': 'KI-Antworten aktiviert',
  'directChat.aiToggleDisabled': 'KI-Antworten deaktiviert',
  'directChat.aiGenerating': 'KI antwortet…',
  'directChat.aiGenerationError': 'Fehler beim Generieren der KI-Antwort: {error}',
  'directChat.aiChooseModel': 'KI-Modell auswählen',
  'directChat.aiLongPressHint': 'Gedrückt halten zur Modellauswahl',
  'directChat.sent': 'Gesendet',
  'directChat.delivered': 'Zugestellt',
  'directChat.read': 'Gelesen',

  'sidebar.title': 'Chats',
  'sidebar.newChat': 'Neuer Chat',
  'sidebar.search': 'Suchen',
  'sidebar.searchPlaceholder': 'Chats durchsuchen…',
  'sidebar.projects': 'Projekte',
  'sidebar.newProject': 'Neues Projekt',
  'sidebar.noConversations': 'Noch keine Unterhaltungen',
  'sidebar.archived': 'Archiviert',
  'sidebar.showArchived': 'Archiv anzeigen',
  'sidebar.hideArchived': 'Archiv ausblenden',
  'sidebar.pinned': 'Angeheftet',
  'sidebar.today': 'Heute',
  'sidebar.yesterday': 'Gestern',
  'sidebar.previous7Days': 'Letzte 7 Tage',
  'sidebar.previous30Days': 'Letzte 30 Tage',
  'sidebar.older': 'Älter',

  'menu.rename': 'Umbenennen',
  'menu.pin': 'Anheften',
  'menu.unpin': 'Lösen',
  'menu.archive': 'Archivieren',
  'menu.unarchive': 'Aus Archiv',
  'menu.addToFolder': 'Zum Ordner hinzufügen',
  'menu.moveUp': 'Nach oben',
  'menu.moveDown': 'Nach unten',
  'menu.delete': 'Löschen',
  'menu.deleteTitle': 'Chat löschen?',
  'menu.deleteConfirm': 'Diese Unterhaltung und ihre Nachrichten werden dauerhaft gelöscht.',

  'project.name': 'Projektname',
  'project.description': 'Beschreibung',
  'project.systemPrompt': 'Eigene Anweisungen',
  'project.systemPromptHint': 'Diese Anweisungen gehen bei jedem Chat des Projekts an das Modell.',
  'project.create': 'Projekt erstellen',
  'project.empty': 'Noch keine Projekte',

  'composer.placeholder': 'Nachricht an Volt…',
  'composer.imagePlaceholder': 'Beschreibe das gewünschte Bild…',
  'composer.videoPlaceholder': 'Beschreibe das gewünschte Video…',
  'composer.characterPlaceholder': 'Beschreibe den Charakter…',
  'composer.audioPlaceholder': 'Beschreibe die Musik oder das Audio…',
  'composer.voicePlaceholder': 'Text zum Vorlesen…',

  'character.tabSoulId': 'Soul ID',
  'character.tabCharacter': 'Charakter',
  'character.tabSoulCast': 'Soul Cast',
  'character.tabAiInfluencer': 'KI-Influencer',
  'character.soulIdTitle': 'Soul ID trainieren',
  'character.characterTitle': 'Charaktere',
  'character.soulCastTitle': 'Soul Cast',
  'character.aiInfluencerTitle': 'KI-Influencer',
  'character.name': 'Name',
  'character.description': 'Beschreibung',
  'character.bio': 'Bio',
  'character.style': 'Stil',
  'character.scene': 'Szene',
  'character.prompt': 'Prompt',
  'character.referenceImages': 'Referenzbild-URLs, eine pro Zeile',
  'character.pickSoulId': 'Soul ID auswählen',
  'character.pickCharacter': 'Charakter auswählen',
  'character.noSoulLinked': 'Keine Soul ID verknüpft',
  'character.scopeLabel': 'Was erstellen',
  'character.scopeHead': 'Kopf',
  'character.scopeFullBody': 'Ganzkörper',
  'character.scopeHeadHint': 'Gesichts-Nahaufnahmen aus verschiedenen Winkeln funktionieren am besten.',
  'character.scopeFullBodyHint': 'Füge Ganzkörperfotos hinzu, damit der ganze Körper erstellt werden kann.',
  'character.scopeBadgeHead': 'Kopf',
  'character.scopeBadgeFullBody': 'Ganzkörper',
  'character.model3dCreate': '3D-Modell erstellen',
  'character.model3dView': 'In 3D ansehen',
  'character.model3dBuilding': '3D-Modell wird erstellt … das dauert einige Minuten.',
  'character.model3dFailed': '3D-Modell konnte nicht erstellt werden',
  'character.model3dRetry': 'Erneut versuchen',
  'character.model3dStarted': '3D-Modell wird erstellt',
  'character.model3dStage': '3D-Modell-Ansicht',
  'character.model3dLoading': 'Modell wird geladen …',
  'character.model3dError': '3D-Modell konnte nicht geöffnet werden.',
  'character.model3dUnsupported': 'Dein Gerät unterstützt kein 3D (WebGL).',
  'character.model3dHint': 'Ziehen zum Drehen · Zoomen per Pinch oder Mausrad',
  'character.model3dReset': 'Ansicht zurücksetzen',
  'character.model3dAutoRotate': 'Automatisch drehen',
  'character.soulIdPhotoHint': 'Lade 5–20 Referenzfotos hoch.',
  'character.soulIdPhotoCount': 'Bitte 5 bis 20 Fotos auswählen.',
  'character.soulIdUploadFailed': 'Fotos konnten nicht hochgeladen werden. Bitte erneut versuchen.',
  'character.createSoulId': 'Soul ID erstellen',
  'character.createCharacter': 'Charakter erstellen',
  'character.createAiInfluencer': 'KI-Influencer erstellen',
  'character.generateSoulCast': 'Soul Cast erzeugen',
  'character.generateContent': 'Inhalt erzeugen',
  'character.status.training': 'Wird trainiert',
  'character.status.ready': 'Bereit',
  'character.status.failed': 'Fehlgeschlagen',
  'composer.send': 'Senden',
  'composer.stop': 'Stoppen',
  'composer.attach': 'Dateien anhängen',
  'composer.attachTitle': 'Anhang hinzufügen',
  'composer.attachAllPhotos': 'Alle Fotos',
  'composer.attachCamera': 'Kamera',
  'composer.attachPhotos': 'Fotos',
  'composer.attachFiles': 'Dateien',
  'composer.attachFilesHint': 'Fotos ohne Komprimierung',
  'composer.attachToFolder': 'Zu Ordner hinzufügen',
  'composer.voiceInput': 'Spracheingabe',
  'composer.listening': 'Höre zu…',
  'composer.thinking': 'Denke nach…',
  'composer.model': 'Modell',
  'composer.selectModel': 'Modell wählen',
  'composer.unavailable': 'Nicht verfügbar',
  'composer.estimate': '≈ {price}',
  'composer.topUpHint': 'Lade dein Guthaben auf {amount} auf, um weiterzuschreiben',
  'composer.generate': 'Generieren',

  'message.copy': 'Kopieren',
  'message.copied': 'Kopiert',
  'message.share': 'Teilen',
  'message.regenerate': 'Neu generieren',
  'message.edit': 'Bearbeiten',
  'message.save': 'Speichern & senden',
  'message.up': 'Gute Antwort',
  'message.down': 'Schlechte Antwort',
  'message.usage': '{model} · {input} rein · {output} raus · {cost}',
  'message.usageNoModel': '{input} rein · {output} raus · {cost}',
  'message.failed': 'Generierung fehlgeschlagen',
  'message.reasoningTitle': 'Verarbeitungsschritte',
  'conversation.pinnedBadge': 'Angehefteter Chat',

  // TODO: translate share keys
  'share.button': 'Share',
  'share.createLink': 'Create link',
  'share.copyLink': 'Copy link',
  'share.copied': 'Copied!',
  'share.revoke': 'Revoke link',
  'share.revokeConfirm':
    'Are you sure you want to revoke this link? Anyone with the link will no longer be able to access it.',
  'share.title': 'Share conversation',
  'share.sharedBy': 'Shared snapshot',
  'share.notFound': 'This link has expired or been revoked.',
  'share.openApp': 'Open Volt',
  'share.loading': 'Loading…',
  'share.sendToChat': 'In den Chat senden',
  'share.noDestinations': 'Keine Chats oder Gruppen verfügbar',
  'share.sentSuccess': 'Gesendet!',
  'share.sending': 'Wird gesendet…',
  'share.loadingDestinations': 'Chats laden…',
  'artifact.preview': 'Vorschau',
  'artifact.code': 'Code',
  'artifact.open': 'Artefakt öffnen',
  'artifact.export': 'Exportieren',
  'artifact.download': 'Herunterladen',
  'artifact.copy': 'Kopieren',
  'artifact.edit': 'Bearbeiten',
  'artifact.close': 'Schließen',
  'artifact.fullscreen': 'Vollbild',

  'job.status': 'Status',
  'job.pending': 'In Warteschlange',
  'job.processing': 'Wird verarbeitet…',
  'job.done': 'Fertig',
  'job.failed': 'Fehlgeschlagen',
  'job.cancelled': 'Abgebrochen',
  'job.result': 'Ergebnis',
  'job.empty': 'Noch keine Generierungen',
  'job.actions': 'Aktionen',
  'job.favoriteAdd': 'Zu Favoriten hinzufügen',
  'job.favoriteRemove': 'Aus Favoriten entfernen',
  'job.favorited': 'Favorit',
  'job.regenerate': 'Neu generieren',
  'job.viewPrompt': 'Prompt ansehen',
  'job.promptTitle': 'Prompt',
  'job.download': 'Herunterladen',
  'job.deleteTitle': 'Generierung löschen?',
  'job.deleteConfirm': 'Diese Generierung wird endgültig gelöscht.',

  'design.subtitle': 'Öffne ein Design-Tool in einem neuen Fenster',
  'design.open': 'Öffnen',

  'settings.title': 'Einstellungen',
  'settings.profile': 'Profil',
  'settings.appearance': 'Darstellung',
  'settings.theme': 'Design',
  'settings.themeLight': 'Hell',
  'settings.themeDark': 'Dunkel',
  'settings.themeSystem': 'System',
  'settings.language': 'Sprache',
  'settings.balance': 'Guthaben',
  'settings.topup': 'Aufladen',
  'settings.topupAmount': 'Betrag, ₽',
  'settings.topupSubmit': 'Guthaben aufladen',
  'settings.transactions': 'Transaktionsverlauf',
  'settings.noTransactions': 'Noch keine Transaktionen',
  'settings.loadMore': 'Mehr laden',
  'settings.notifications': 'Benachrichtigungen',
  'settings.notificationsHint': 'Benachrichtigen, wenn Generierungen fertig sind',
  'settings.data': 'Deine Daten',
  'settings.exportData': 'Meine Daten exportieren',
  'settings.deleteAccount': 'Konto löschen',
  'settings.deleteAccountTitle': 'Konto löschen?',
  'settings.deleteAccountConfirm':
    'Dies löscht dein Konto, deine Unterhaltungen und dein Guthaben dauerhaft. Nicht umkehrbar.',
  'settings.username': 'Benutzername',
  'settings.name': 'Name',

  'admin.title': 'Admin',
  'admin.stats': 'Statistik',
  'admin.users': 'Nutzer',
  'admin.settings': 'Plattform-Einstellungen',
  'admin.markup': 'Aufschlag, %',
  'admin.usdRub': 'USD → RUB Kurs',
  'admin.minBalance': 'Min. Guthaben, ₽',
  'admin.contextLimit': 'Kontext-Nachrichten',
  'admin.models': 'Modellpreise',
  'admin.price': 'Preis',
  'admin.revenue': 'Umsatz',
  'admin.cost': 'Anbieterkosten',
  'admin.margin': 'Marge',
  'admin.activeUsers': 'Aktiv (24 h)',
  'admin.failedJobs': 'Fehlgeschlagene Jobs',
  'admin.ban': 'Sperren',
  'admin.unban': 'Entsperren',
  'admin.adjustBalance': 'Guthaben anpassen',
  'admin.reason': 'Grund',
  'admin.amount': 'Betrag, ₽',
  'admin.errorHistory': 'Fehlerprotokoll',
  'admin.errorsEmpty': 'Noch keine Fehler aufgezeichnet.',

  'error.UNAUTHORIZED': 'Deine Sitzung ist abgelaufen. Öffne die App erneut.',
  'error.FORBIDDEN': 'Du hast darauf keinen Zugriff.',
  'error.USER_BANNED': 'Dein Konto wurde gesperrt.',
  'error.NOT_FOUND': 'Nicht gefunden.',
  'error.RATE_LIMITED': 'Zu viele Anfragen. Bitte langsamer.',
  'error.DAILY_LIMIT_EXCEEDED': 'Tageslimit erreicht. Versuch es morgen.',
  'error.INSUFFICIENT_BALANCE': 'Nicht genug Guthaben für diese Anfrage.',
  'error.BELOW_MIN_BALANCE': 'Dein Guthaben liegt unter dem Minimum.',
  'error.MODEL_UNAVAILABLE': 'Dieses Modell ist derzeit nicht verfügbar.',
  'error.MODEL_NOT_SUPPORTED': 'Dieses Modell wird hier nicht unterstützt.',
  'error.PROVIDER_ERROR': 'Der Anbieter hat einen Fehler gemeldet.',
  'error.PROVIDER_TIMEOUT': 'Zeitüberschreitung beim Anbieter.',
  'error.CONTEXT_TOO_LARGE': 'Diese Unterhaltung ist zu lang für das Modell.',
  'error.PAYMENT_INVALID': 'Die Zahlung konnte nicht verarbeitet werden.',
  'error.INTERNAL': 'Serverfehler. Bitte erneut versuchen.',
  'error.network': 'Netzwerkfehler. Prüfe deine Verbindung.',
  'error.streamInterrupted':
    'Verbindung unterbrochen. Die Antwort wurde vom Server wiederhergestellt.',
  'error.generic': 'Etwas ist schiefgelaufen.',
};
